import { PageOption } from "components/dynamic-content/util/dynamicContent"
import React from "react"

interface TalkToCarrotContextProps {
  talkToCarrotLocationOptions: Array<PageOption>
}
const TalkToCarrotContext = React.createContext<TalkToCarrotContextProps>({ talkToCarrotLocationOptions: [] })

export { TalkToCarrotContext }
